/**
 * Phone, side by side (spec 15.18): while both videos play, both are
 * muted, whatever their own settings; otherwise each has its own (muted,
 * or slowed below 1x, as applyVideoState sets it). Pure apart from the
 * elements it is handed, for unit tests.
 */
type Ref<T> = { current: T };
interface MediaLike { paused: boolean; muted: boolean }

export interface PairMuteRefs {
  phone: Ref<boolean>;
  two: Ref<boolean>;
  v1: Ref<MediaLike | null>;
  v2: Ref<MediaLike | null>;
  m1: Ref<boolean>;
  m2: Ref<boolean>;
  s1: Ref<number>;
  s2: Ref<number>;
}

/**
 * Sets both elements' `muted`. `starting` is a panel about to play,
 * counted as playing so its sound never overlaps the other's. Returns
 * whether both play. Desktop, or one video: does nothing, so each element
 * keeps exactly what applyVideoState gave it.
 */
export function syncPairMutes(r: PairMuteRefs, starting?: 1 | 2): boolean {
  if (!r.phone.current || !r.two.current) return false;
  const v1 = r.v1.current;
  const v2 = r.v2.current;
  const plays = (v: MediaLike | null, id: 1 | 2) => !!v && (!v.paused || starting === id);
  const both = plays(v1, 1) && plays(v2, 2);
  if (v1) v1.muted = r.m1.current || r.s1.current < 1 || both;
  if (v2) v2.muted = r.m2.current || r.s2.current < 1 || both;
  return both;
}
